import Marquee from "react-fast-marquee";
import { useContent } from "@/lib/useContent";

export default function EditorialMarquee() {
  const { content } = useContent();
  return (
    <div
      data-testid="editorial-marquee"
      className="py-10 md:py-14 border-y border-[#2C2C2C] bg-[#080808] overflow-hidden"
    >
      <Marquee gradient={false} speed={30} pauseOnHover>
        {content.marquee.map((word, i) => (
          <span
            key={i}
            className="font-display italic text-6xl md:text-8xl lg:text-9xl tracking-tighter mx-8 md:mx-14 text-white/80"
          >
            {word}
            <span className="text-[#C67022] mx-6 md:mx-10">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
